import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum ActionTriggerType {
    PUBLISH = "publish",
    EXECUTE = "execute",
    SUBMIT = "submit",
}

export interface PulseSurveyTriggerState {
    /** When an action trigger fires, this is set to the trigger type (publish/execute/submit) */
    pendingTrigger: ActionTriggerType | null;
    /** Timestamp when the trigger was fired - used to deduplicate */
    triggerTimestamp: number | null;
}

const initialState: PulseSurveyTriggerState = {
    pendingTrigger: null,
    triggerTimestamp: null,
};

const pulseSurveyTriggerSlice = createSlice({
    name: "pulseSurveyTrigger",
    initialState,
    reducers: {
        setPendingTrigger: {
            reducer(state, action: PayloadAction<{ trigger: ActionTriggerType; timestamp: number }>) {
                state.pendingTrigger = action.payload.trigger;
                state.triggerTimestamp = action.payload.timestamp;
            },
            prepare(trigger: ActionTriggerType) {
                return { payload: { trigger, timestamp: Date.now() } };
            },
        },
        clearPendingTrigger(state) {
            state.pendingTrigger = null;
            state.triggerTimestamp = null;
        },
    },
});

export const { setPendingTrigger, clearPendingTrigger } = pulseSurveyTriggerSlice.actions;
export default pulseSurveyTriggerSlice.reducer;
